import React, { useMemo } from 'react'
import SharedStack from '~components/shared/wrappers/shared-stack'
import { Text } from '@chakra-ui/react'
import {
    ChatMessageFieldsFragment,
    NotificationLogMessageFieldsFragment,
} from '~graphql/generated/graphql'
import PostcardPreviewButton from './postcard-preview-button'
import { useNotificationLogsContext } from '../provider'
import {
    getMessageNotificationRefs,
    hasPostcardContent,
    resolveNotificationPreviewContent,
} from './resolve-preview-content'

export default function NotificationPostcardPreviews({
    message,
}: {
    message: ChatMessageFieldsFragment | NotificationLogMessageFieldsFragment
}) {
    const { notificationTemplates = [] } = useNotificationLogsContext()

    const postcardNotifications = useMemo(() => {
        const refs = getMessageNotificationRefs(message)
        if (!refs.length) return []

        const resolved = refs.map(ref =>
            resolveNotificationPreviewContent(ref, notificationTemplates),
        )

        // Prefer known postcard content. If templates aren't loaded (or a
        // template was archived/hidden), still keep refs so preview can
        // lazy-fetch HTML on open.
        const withContent = resolved.filter(hasPostcardContent)
        return withContent.length ? withContent : resolved
    }, [message, notificationTemplates])

    if (!postcardNotifications.length) return null

    return (
        <SharedStack>
            {postcardNotifications.map(notif => (
                <SharedStack row key={notif.id} spacing={1}>
                    <Text>Postcard sent for</Text>
                    <PostcardPreviewButton
                        message={message}
                        notification={notif}
                    />
                </SharedStack>
            ))}
        </SharedStack>
    )
}
